import React, { Component, createRef } from 'react';
import FJUtil from '../../../../util/FJUtil';
import classNames from 'classnames';
import Style from './FJSlider.module.less';

const percentStyle = progress => {
    return progress * 100 + '%';
};

class FJSlider extends Component {
    constructor(props) {
        super(props);
        let { defaultValue = 100, min = 0, max = 100, vertical = false, range } = props;
        defaultValue = range ? (defaultValue ? defaultValue : [min, max]) : defaultValue;
        this.tagProgress = 0;
        this.containerRef = createRef();
        this.state = {
            progress: range ? [defaultValue[0] / max, defaultValue[1] / max] : defaultValue / max, // 0 -> 1
            defaultValue: defaultValue,
            min: min,
            max: max,
            isDragging: false,
            vertical: vertical,
        };
    }

    componentDidMount() {
        if (this.props.useNative) {
            FJUtil.addEvent(this.containerRef.current, 'mousedown', this.onMouseDown);
        }
    }

    onMouseDown = e => {
        e.preventDefault();
        this.setState(
            {
                isDragging: true,
                progress: this.convertToProgress(e),
            },
            () => {
                FJUtil.addEvent(document, 'mousemove', this.onMouseMove);
                FJUtil.addEvent(document, 'mouseup', this.onMouseUp);
                this.onBeforeChange();
                this.onChange();
            },
        );
    };
    onMouseMove = e => {
        this.setState(
            {
                progress: this.convertToProgress(e),
            },
            () => {
                this.onChange();
            },
        );
    };
    onMouseUp = e => {
        this.setState(
            {
                isDragging: false,
            },
            () => {
                FJUtil.removeEvent(document, 'mousemove', this.onMouseMove);
                FJUtil.removeEvent(document, 'mouseup', this.onMouseUp);
                this.onAfterChange();
            },
        );
    };
    onBeforeChange = () => {
        let { onBeforeChange } = this.props;
        if (onBeforeChange) {
            onBeforeChange(this.getValue(), this.getProgress());
        }
    };
    onChange = () => {
        let { onChange } = this.props;
        if (onChange) {
            onChange(this.getValue(), this.getProgress());
        }
    };
    onAfterChange = () => {
        let { onAfterChange } = this.props;
        if (onAfterChange) {
            onAfterChange(this.getValue(), this.getProgress());
        }
    };
    getValue = () => {
        let { progress, min, max } = this.state;
        let duration = max - min;
        return this.props.range ? [duration * progress[0], duration * progress[1]] : duration * progress;
    };
    setValue = value => {
        let { min, max } = this.state;
        let duration = max - min;
        if (this.props.range) {
            this.setState({ progress: [value[0] / duration, value[1] / duration] });
        } else {
            this.setState({ progress: value / duration });
        }
    };
    getProgress = () => {
        return this.state.progress;
    };
    setProgress = (progress, callback) => {
        this.setState({ progress: progress }, () => {
            if (callback) {
                callback();
            }
        });
    };
    convertToProgress = e => {
        if (!this.containerRef.current) {
            return;
        }

        let point = {
            left: e.clientX,
            top: e.clientY,
        };
        let rect = this.containerRef.current.getBoundingClientRect();

        let getHorPointProgress = (point, rect) => {
            let pointValue = point.left - rect.left;
            pointValue = FJUtil.valueOfInterval(pointValue, 0, rect.width);
            return pointValue / rect.width;
        };

        if (this.props.range) {
            let pointProgress = getHorPointProgress(point, rect);
            let progress = this.state.progress;
            if (e.type === 'mousedown') {
                if (Math.abs(pointProgress - progress[0]) < Math.abs(pointProgress - progress[1])) {
                    this.tagProgress = progress[1];
                } else {
                    this.tagProgress = progress[0];
                }
            }
            return [this.tagProgress, pointProgress].sort((a, b) => {
                return a - b;
            });
        } else {
            let value = 0;
            let progress = 0;
            if (this.state.vertical) {
                value = rect.top + rect.height - point.top;
                value = FJUtil.valueOfInterval(value, 0, rect.height);
                progress = value / rect.height;
            } else {
                value = point.left - rect.left;
                value = FJUtil.valueOfInterval(value, 0, rect.width);
                progress = value / rect.width;
            }
            return progress;
        }
    };

    render() {
        let { range, className = '', sliderClass, railClass, handleClass, trackClass } = this.props;
        let { vertical, progress } = this.state;
        progress = typeof this.props.progress === 'undefined' ? progress : this.props.progress;
        let _sliderClass = classNames(Style.slider, sliderClass, className, {
            [Style.vertical]: vertical,
            [Style.horizontal]: !vertical,
        });
        let trackStyle = {};
        let handleStyle = {};
        let handleMinStyle = {};
        let handleMaxStyle = {};
        if (range) {
            handleMinStyle.left = percentStyle(progress[0]);
            handleMaxStyle.left = percentStyle(progress[1]);
            trackStyle.width = percentStyle(progress[1] - progress[0]);
            trackStyle.left = handleMinStyle.left;
        } else {
            if (vertical) {
                trackStyle.height = percentStyle(progress);
                handleStyle.bottom = percentStyle(progress);
            } else {
                trackStyle.width = percentStyle(progress);
                handleStyle.left = percentStyle(progress);
            }
        }
        return (
            <div
                className={_sliderClass}
                ref={this.containerRef}
                onMouseDown={e => {
                    if (this.props.useNative) {
                        return;
                    }
                    this.onMouseDown(e);
                }}
            >
                <div className={classNames(Style.rail, railClass)} />
                <div className={classNames(Style.track, trackClass)} style={trackStyle} />
                {range ? (
                    <>
                        <div className={classNames(Style.handle, handleClass)} style={handleMinStyle} />
                        <div className={classNames(Style.handle, handleClass)} style={handleMaxStyle} />
                    </>
                ) : (
                    <div className={classNames(Style.handle, handleClass)} style={handleStyle} />
                )}
            </div>
        );
    }
}

export default FJSlider;
